import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#entity_target",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light" }, "Pending Training Target List")
  ])
], -1)
const _hoisted_3 = {
  id: "entity_target",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-6" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, "Tranche"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-1 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Tranche"
  })
], -1)
const _hoisted_10 = { class: "col-md-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Training Partner", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = { class: "col-md-2 mt-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "card mb-5 mb-xl-10" }
const _hoisted_17 = {
  id: "entity_target_list",
  class: "collapse show"
}
const _hoisted_18 = { class: "collapse show" }
const _hoisted_19 = { class: "card-body border-top p-0" }
const _hoisted_20 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-light px-4",
  role: "button",
  "data-bs-target": "#trainee_data",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "row mt-1 w-100 m-0" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" }, [
        /*#__PURE__*/_createElementVNode("input", {
          type: "text",
          class: "form-control ps-10 w-200px mt-1 form-control-sm",
          style: {"height":"1em"},
          placeholder: "Search"
        })
      ])
    ])
  ])
], -1)
const _hoisted_22 = {
  id: "trainee_data",
  class: "collapse show"
}
const _hoisted_23 = { class: "collapse show" }
const _hoisted_24 = { class: "card-body border-top p-6" }
const _hoisted_25 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check text-light" }, null, -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye text-light" }, null, -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("i", { class: "fas text-light fa-pencil-alt" }, null, -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times text-light" }, null, -1)
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt text-light" }, null, -1)
const _hoisted_40 = [
  _hoisted_39
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_Form = _resolveComponent("Form")!
  const _component_TargetListModal = _resolveComponent("TargetListModal")!
  const _component_TargetChangeSummeryModal = _resolveComponent("TargetChangeSummeryModal")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Form, {
      onSubmit: _cache[3] || (_cache[3] = ($event: any) => (_ctx.formSubmit())),
      class: "form",
      "validation-schema": _ctx.AssociationSchema
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _hoisted_9,
                      _createVNode(_component_Multiselect, {
                        modelValue: _ctx.entity.tranche_id,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.entity.tranche_id) = $event)),
                        options: _ctx.optionsTranche,
                        mode: "tags",
                        "clear-on-select": false,
                        placeholder: "Select Tranche",
                        "close-on-select": false,
                        searchable: true,
                        "create-option": true
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _hoisted_12,
                      _createVNode(_component_Multiselect, {
                        modelValue: _ctx.associationData,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.associationData) = $event)),
                        options: _ctx.tempId,
                        mode: "tags",
                        "clear-on-select": false,
                        placeholder: "Select Training Partner",
                        "close-on-select": false,
                        searchable: true,
                        "create-option": true
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("button", {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.targetDataList())),
                        type: "button",
                        class: "btn btn-success mt-6 p-3",
                        style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                      }, [
                        _createTextVNode(" Search "),
                        _hoisted_14
                      ])
                    ])
                  ]),
                  (_ctx.showtargetList == true)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: _ctx.componentKey,
                        class: "mt-3"
                      }, [
                        (_ctx.showtargetList == true)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                              _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("div", _hoisted_17, [
                                  _createElementVNode("div", _hoisted_18, [
                                    _createElementVNode("div", _hoisted_19, [
                                      _createElementVNode("div", _hoisted_20, [
                                        _createElementVNode("div", null, [
                                          _hoisted_21,
                                          _createElementVNode("div", _hoisted_22, [
                                            _createElementVNode("div", _hoisted_23, [
                                              _createElementVNode("div", _hoisted_24, [
                                                _createElementVNode("div", _hoisted_25, [
                                                  _createVNode(_component_Datatable, {
                                                    "table-data": _ctx.targetList,
                                                    "table-header": _ctx.tableHeader,
                                                    "enable-items-per-page-dropdown": true
                                                  }, {
                                                    "cell-id": _withCtx(({ row }) => [
                                                      _createTextVNode(_toDisplayString(row.id), 1)
                                                    ]),
                                                    "cell-tranche": _withCtx(({
                                          row: industry,
                                        }) => [
                                                      _createTextVNode(_toDisplayString(industry.tranche_info.label), 1)
                                                    ]),
                                                    "cell-association": _withCtx(({
                                          row: industry,
                                        }) => [
                                                      _createTextVNode(_toDisplayString(industry.entity_info
                                              .entity_short_name), 1)
                                                    ]),
                                                    "cell-year_id": _withCtx(({
                                              row: industry,
                                            }) => [
                                                      _createTextVNode(_toDisplayString(industry.target_year_info.name), 1)
                                                    ]),
                                                    "cell-targetYearFrom": _withCtx(({
                                          row: industry,
                                        }) => [
                                                      _createTextVNode(_toDisplayString(industry.target_year_from), 1)
                                                    ]),
                                                    "cell-targetYearTo": _withCtx(({
                                          row: industry,
                                        }) => [
                                                      _createTextVNode(_toDisplayString(industry.target_year_to), 1)
                                                    ]),
                                                    "cell-traineeNumber": _withCtx(({
                                          row: industry,
                                        }) => [
                                                      _createTextVNode(_toDisplayString(industry.target_trainee_number), 1)
                                                    ]),
                                                    "cell-actions": _withCtx(({
                                          row: industry,
                                        }) => [
                                                      _createElementVNode("button", {
                                                        onClick: ($event: any) => (_ctx.Approve(industry.id)),
                                                        class: "btn btn-icon btn-bg-success btn-active-color-primary btn-sm mr-2",
                                                        title: "Approve"
                                                      }, _hoisted_28, 8, _hoisted_26),
                                                      _createElementVNode("button", {
                                                        "data-kt-drawer-toggle": "true",
                                                        "data-kt-drawer-target": "#kt_drawer_target_change_summery",
                                                        onClick: ($event: any) => (_ctx.view(industry)),
                                                        id: "kt_drawer_target_change_summery_button",
                                                        title: "View",
                                                        class: "btn btn-icon btn-bg-info btn-active-color-primary btn-sm me-1"
                                                      }, _hoisted_31, 8, _hoisted_29),
                                                      _createElementVNode("button", {
                                                        "data-kt-drawer-toggle": "true",
                                                        "data-kt-drawer-target": "#kt_drawer_target_list",
                                                        onClick: ($event: any) => (_ctx.edit(industry)),
                                                        id: "kt_drawer_target_list_button",
                                                        title: "Edit",
                                                        class: "btn btn-icon btn-bg-primary btn-active-color-primary btn-sm me-1"
                                                      }, _hoisted_34, 8, _hoisted_32),
                                                      _createElementVNode("button", {
                                                        onClick: ($event: any) => (_ctx.Reject(industry.id)),
                                                        class: "btn btn-icon btn-bg-warning btn-active-color-danger btn-sm me-1",
                                                        title: "Reject"
                                                      }, _hoisted_37, 8, _hoisted_35),
                                                      _createElementVNode("button", {
                                                        onClick: ($event: any) => (_ctx.Delete(industry.id)),
                                                        class: "btn btn-icon btn-bg-danger btn-active-color-danger btn-sm",
                                                        title: "Delete"
                                                      }, _hoisted_40, 8, _hoisted_38)
                                                    ]),
                                                    _: 1
                                                  }, 8, ["table-data", "table-header"])
                                                ])
                                              ])
                                            ])
                                          ])
                                        ])
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])), [
            [_directive_loading, _ctx.load]
          ])
        ])), [
          [_directive_loading, _ctx.load]
        ])
      ]),
      _: 1
    }, 8, ["validation-schema"]),
    _createVNode(_component_TargetListModal),
    _createVNode(_component_TargetChangeSummeryModal)
  ], 64))
}